import React from 'react';
import { ChevronDownIcon, XIcon } from 'lucide-react';
import { flujoDolor, dolores } from '../data/content';
export function IdentificationSection() {
  return <section className="w-full bg-canvas px-4 py-9 sm:px-6 sm:py-12" data-id="element-101" data-mp="16eucq31ab2a4">
      <div className="mx-auto max-w-3xl text-center" data-id="element-102" data-mp="1ah8xwtsfee4k">
        <h2 className="mx-auto max-w-2xl font-display text-[1.25rem] font-extrabold uppercase leading-tight text-brand-deep sm:text-3xl" data-id="element-103" data-mp="1fa213d88xeej">
          ¿Sientes que intentas hacerlo bien, pero nunca logras mantener el
          orden?
        </h2>

        <ol className="mx-auto mt-5 flex max-w-xs flex-col items-center sm:max-w-sm" data-id="element-104" data-mp="1p652ggv9x90f">
          {flujoDolor.map((paso, i) => <li key={paso} className="flex w-full flex-col items-center" data-id="element-105" data-mp="1u4yioh1y3e4a" data-mpi={i}>
              {i > 0 && <ChevronDownIcon className="my-0.5 h-3.5 w-3.5 text-accent" aria-hidden="true" data-id="element-106" data-mp="3vy5uhgicndlf" />}
              <span className="w-full rounded-lg border border-gray-200 bg-white px-3 py-1.5 font-display text-[0.75rem] font-extrabold uppercase tracking-wide text-brand-deep sm:text-sm" data-id="element-107" data-mp="3uvgm088zpu3">
                {paso}
              </span>
            </li>)}
        </ol>

        <p className="mx-auto mt-5 max-w-xl rounded-xl bg-brand-deep px-4 py-4 font-display text-[0.95rem] font-extrabold uppercase leading-snug text-white sm:text-lg" data-id="element-108" data-mp="3rrd5xmowhs3o">
          Quizás el problema no es tu esfuerzo.{' '}
          <span className="text-accent" data-id="element-109" data-mp="o933o7r9otek">
            Es no tener un sistema que puedas seguir.
          </span>
        </p>

        <ul className="mx-auto mt-4 grid max-w-2xl grid-cols-2 gap-2 text-left" data-id="element-110" data-mp="j8nr3iet7pxn">
          {dolores.map(dolor => <li key={dolor} className="flex items-start gap-1.5 rounded-lg border border-gray-200 bg-white px-2.5 py-2 text-[0.78rem] leading-tight text-gray-700 sm:px-3 sm:text-sm" data-id="element-111" data-mp="9ckq4fvp1xca">
              <XIcon className="mt-px h-3.5 w-3.5 shrink-0 text-accent" aria-hidden="true" data-id="element-112" data-mp="2u2a1gix6v108" />
              {dolor}
            </li>)}
        </ul>

        <p className="mx-auto mt-4 max-w-xl text-[0.85rem] leading-snug text-gray-600 sm:text-[0.95rem]" data-id="element-113" data-mp="1q3oa5hj3nts1">
          Metabolismo Reset fue creado para ayudarte a dejar de improvisar y
          construir una rutina más clara, práctica y sostenible.
        </p>
      </div>
    </section>;
}